module.exports = __webpack_public_path__ + "files/7e7c196a8515881699149db7ac1a3804.png";